import React, { useEffect, useState } from "react";
import '../../assets/images/favicon.ico';
import '../../assets/css/bootstrap.min.css';
import '../../assets/vendors/css/vendors.min.css';
import '../../assets/vendors/css/dataTables.bs5.min.css';
import '../../assets/vendors/css/daterangepicker.min.css';
import '../../assets/css/theme.min.css';
import AuthorTable from './AuthorTable'
import axios from "axios";
import LineChart from "./chart/LineChart";
import VerticalBarChart from "./chart/VerticalBarChart";
import AdminLayout from "./component/AdminLayout";

const AuthorList = () => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleTheme = (event: React.MouseEvent) => {
        event.preventDefault(); // 기본 동작 방지 (링크 클릭 시 페이지 이동 방지)
        setIsDarkMode((prevMode) => !prevMode); // 테마 변경
    };

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked); // 체크박스 상태를 반영
    };

    const data = [10, 20, 30, 40, 50];
    const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May'];

    return (
        <AdminLayout
            pageTitle="승인 작가"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Proposal', active: true }
            ]}
        >
            <div className="main-content">
                <div className="row">
                    <AuthorTable status={'ACTIVE'} />
                </div>
            </div>
        </AdminLayout>
    )

}

export default AuthorList;
